(ns common.schema.entities.account.permissions)

(defn read-permissions?
  [{:keys [role]}]
  ;; account is accessible for any authenticated user
  true)

(defn disable-permissions?
  [{:keys []}]
  ;; never allowed
  "Not allowed")
